module.exports = {"id":"236532","name":"Robin Koch","rating":"71","photo":"./data/images/photos/4/236532.png","club":{"name":"SC Fribourg","logo":"./data/images/clubs/SCFribourg.png"},"positions":["DC","MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RobinKoch0.json
// module id = 3649
// module chunks = 0